import trackingCore from '@shopgate/tracking-core/core/Core';
import { appWillStart$ } from '@shopgate/pwa-common/streams/app';
import { redirects } from '@shopgate/pwa-common/collections';
import { CHECKOUT_PATH } from '@shopgate/pwa-common/constants/RoutePaths';
import { isUserLoggedIn } from '@shopgate/pwa-common/selectors/user';
import { LEGACY_URL } from '@shopgate/pwa-common-commerce/checkout/constants';

export default (subscribe) => {
  /**
   * @param {Object} params The handler parameters.
   * @param {Function} params.getState The Redux getState function.
   * @return {string}
   */
  const redirectHandler = ({ getState }) => {
    if (!isUserLoggedIn(getState())) {
      return '';
    }

    /**
     * Build the complete checkout url. Fallback to the
     * legacy url if the Pipeline returns an invalid url.
     * Add some tracking params for cross domain tracking.
     */
    return trackingCore.crossDomainTracking(LEGACY_URL);
  };

  subscribe(appWillStart$, () => {
    redirects.set(CHECKOUT_PATH, redirectHandler, true);
  });
};
